import { environment } from '../../environments/environment';

export class PaginationModel {
  public pageNumber = 0;
  public totalCount = 0;
  public totalPages = 0;
  public pageSize = environment.defaultPageSize;

  constructor(values?: Partial<PaginationModel>) {
    Object.assign(this, values);
  }
}
